import getProcessedRichtext from "./helpers/getProcessedRichtext";
import ParagraphProps from "./ParagraphProps.interface";
import styles from "./Paragraph.module.scss";

import combineClasses from "helpers/combine-classes";
import React, { FunctionComponent } from "react";

const Paragraph: FunctionComponent<ParagraphProps> = (props): JSX.Element => {
    const processedBodyText = getProcessedRichtext(props.innerHTML);

    return (
        <div className={combineClasses(styles.wrapper, props.className)}>
            <div className={styles.adjustment} dangerouslySetInnerHTML={processedBodyText}>
                {props.children}
            </div>
        </div>
    );
};

export default Paragraph;